<template>
  <div class="box">
    <p class="title" v-if="productTitle">{{productTitle}}</p>
    <ul>
      <li v-for="(item, index) in productContentArr" :key="index">
        <div v-if="item.type === 'left'" class="product-box">
          <img :src="item.img" alt="" :style="item.style">
          <div :style="item.boxStyle">
            <p class="label">{{item.label}}</p>
            <p class="content" v-html="item.content"></p>
          </div>
        </div>
        <div v-else-if="item.type==='right'" class="product-box">
          <div :style="item.boxStyle">
            <p class="label">{{item.label}}</p>
            <p class="content">{{item.content}}</p>
          </div>
          <img :src="item.img" alt="" :style="item.style">
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    productContentArr: {
      type: Array
    },
    productTitle: {
      type: String
    }
  }
}
</script>

<style scoped>
.box{
  padding: 80px 0 100px;
}
.title{
  font-size:34px;
  font-family:PingFang SC;
  font-weight:bold;
  line-height:60px;
  color:rgba(51,51,51,1);
  margin-bottom: 64px;
}
.product-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 360px;
  margin-bottom: 30px;
}
.label{
  font-size:28px;
  font-family:PingFang SC;
  font-weight:bold;
  line-height:40px;
  color:rgba(51,51,51,1);
  text-align: left;
}
.content{
  width: 550px;
  font-size:20px;
  font-family:PingFang SC;
  font-weight:400;
  line-height:35px;
  color:rgba(102,102,102,1);
  text-align: left;
}
.img-left{
  width: 314px;
  margin-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/productContent.vue